import type {
    HttpEvent,
    HttpInterceptorFn
} from "@angular/common/http";
import { isMoment } from "moment";
import { Observable, map } from "rxjs";

const _isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

export const dateInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req.clone({ body: convertRequest(req.body) })).pipe(
    map((response) => {
      return convertResponse(response);
    }),
  ) as Observable<HttpEvent<unknown>>;

  function convertRequest(requestBody: any) {
    if (
      requestBody === null ||
      requestBody === undefined ||
      typeof requestBody !== "object"
    ) {
      return requestBody;
    }

    for (const key of Object.keys(requestBody)) {
      const value = requestBody[key];

      if (value instanceof Date || isMoment(value)) {
        requestBody[key] = value.toISOString().split("T")[0];
      } else if (typeof value === "object") {
        convertRequest(value);
      }
    }

    return requestBody;
  }

  function convertResponse(body: any) {
    if (body === null || body === undefined) {
      return body;
    }
    if (typeof body !== "object") {
      return body;
    }
    for (const key of Object.keys(body)) {
      const value = body[key];
      if (isIsoDateString(value)) {
        body[key] = new Date(value);
      } else if (typeof value === "object") {
        convertResponse(value);
      }
    }
    return body;
  }

  function isIsoDateString(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === "string") {
      return _isoDateFormat.test(value);
    }
    return false;
  }
};
